// Stable per-browser id sent as X-Device-ID (analytics + push).
/**
 * Generate or retrieve a unique device ID (client-side only)
 */
export function getDeviceId(): string | null {
  if (typeof window === "undefined") return null; // SSR safety
  const key = "travela_device_id";
  let deviceId = localStorage.getItem(key);
  if (!deviceId) {
    // Generate a new device ID
    const randomPart = Math.random().toString(36).substring(2, 15);
    const timePart = Date.now().toString(36);
    const navPart = navigator.userAgent.replace(/\W/g, "").substring(0, 10);
    deviceId = `${randomPart}-${timePart}-${navPart}`;
    localStorage.setItem(key, deviceId);
  }
  return deviceId;
}
